import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CloseThick = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16, ...props }, forwardedRef) => {
    return (
      <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.3486 3.84853C14.8172 3.3799 14.8172 2.6201 14.3486 2.15147C13.8799 1.68285 13.1201 1.68285 12.6515 2.15147L8.50005 6.30295L4.34858 2.15147C3.87995 1.68285 3.12015 1.68285 2.65152 2.15147C2.18289 2.6201 2.18289 3.3799 2.65152 3.84853L6.80299 8L2.65152 12.1515C2.18289 12.6201 2.18289 13.3799 2.65152 13.8485C3.12015 14.3172 3.87995 14.3172 4.34858 13.8485L8.50005 9.69706L12.6515 13.8485C13.1202 14.3172 13.8799 14.3172 14.3486 13.8485C14.8172 13.3799 14.8172 12.6201 14.3486 12.1515L10.1971 8L14.3486 3.84853Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default CloseThick
